import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { GOOGLE_CAPTCHA_SITE_KEY_V3 } from "../../../utils/constants/appConstants";
import RefferalPartnerURLPage from "./RefferalPartnerURLPage";

const ReffPartnerSignupWithRecaptcha = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={GOOGLE_CAPTCHA_SITE_KEY_V3}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      <RefferalPartnerURLPage />
    </GoogleReCaptchaProvider>
  );
};

export default ReffPartnerSignupWithRecaptcha;
